class CustomerAddress {
  constructor(id, street, city, zipcode, country, installationComment) {
    this._id = id;
    this._street = street;
    this._city = city;
    this._zipcode = zipcode;
    this._country = country;
    this._installationComment = installationComment;
  }

  // getters

  getId() {
    return this._id;
  }

  getStreet() {
    return this._street;
  }

  getCity() {
    return this._city;
  }

  getZipcode() {
    return this._zipcode;
  }

  getCountry() {
    return this._country;
  }

  getInstallationComment() {
    return this._installationComment;
  }

  // setters
  setId(newId) {
    this._id = newId;
    return this;
  }

  setStreet(newStreet) {
    this._street = newStreet;
    return this;
  }

  setCity(newCity) {
    this._city = newCity;
    return this;
  }

  setZipcode(newZipcode) {
    this._zipcode = newZipcode;
    return this;
  }

  setCountry(newCountry) {
    this._country = newCountry;
    return this;
  }

  setInstallationComment(newInstallationComment) {
    this._installationComment = newInstallationComment;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'CustomerAddress' };
  }

  clone() {
    return new CustomerAddress(
      this._id,
      this._street,
      this._city,
      this._zipcode,
      this._country,
      this._installationComment,
    );
  }
  static deserialize(raw) {
    return new CustomerAddress(
      raw._id,
      raw._street,
      raw._city,
      raw._zipcode,
      raw._country,
      raw._installationComment,
    );
  }
}

export default CustomerAddress;



// WEBPACK FOOTER //
// ./src/models/CustomerAddress.js